import axios from "axios";

// Reserved-area client: every call is forwarded 1:1 to the CRM by our same-domain passthrough.
const crm = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/crm`, timeout: 30000 });

export const SESSION_KEY = "zr_cliente_session";
export const getClienteSession = () => localStorage.getItem(SESSION_KEY);
export const setClienteSession = (t) => localStorage.setItem(SESSION_KEY, t);
export const clearClienteSession = () => localStorage.removeItem(SESSION_KEY);

// Error text exactly as the CRM returns it (detail string or pydantic list).
export function crmError(err, fallback = "Si è verificato un errore. Riprova.") {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((e) => `${(e.loc || []).slice(1).join(".")}: ${e.msg}`).join(" · ");
  if (typeof d === "string" && d) return d;
  if (err?.response?.status === 502) return "Servizio momentaneamente non disponibile. Riprova tra poco.";
  return fallback;
}

const withSession = (extra = {}) => ({ params: { session_token: getClienteSession(), ...extra } });

export const cliente = {
  requestMagicLink: (email) => crm.post("/cliente/magic-link/request", { email }).then((r) => r.data),
  consumeMagicLink: (token) => crm.get("/cliente/magic-link/consume", { params: { token } }).then((r) => r.data),
  requestOtp: (numero_pratica, email) => crm.post("/cliente/login/request-otp", { numero_pratica, email }).then((r) => r.data),
  verifyOtp: (numero_pratica, email, otp) => crm.post("/cliente/login/verify-otp", { numero_pratica, email, otp }).then((r) => r.data),
  me: () => crm.get("/cliente/me", withSession()).then((r) => r.data),
  chats: () => crm.get("/cliente/chats", withSession()).then((r) => r.data),
  messages: (channel) => crm.get(`/cliente/chats/${encodeURIComponent(channel)}`, withSession()).then((r) => r.data),
  send: (channel, payload) =>
    crm.post(`/cliente/chats/${encodeURIComponent(channel)}`, payload, withSession()).then((r) => r.data),
  miniMandato: () => crm.get("/cliente/mini-mandato", { ...withSession(), responseType: "blob" }),
  documenti: () => crm.get("/cliente/documenti", withSession()).then((r) => r.data),
  uploadDocumento: (tipo, file) => {
    const fd = new FormData();
    fd.append("tipo", tipo);
    fd.append("file", file);
    return crm.post("/cliente/documenti", fd, { ...withSession(), timeout: 120000 }).then((r) => r.data);
  },
  proiezioni: () => crm.get("/cliente/proiezione", withSession()).then((r) => r.data),
  proiezioneUrl: (id) =>
    `${process.env.REACT_APP_BACKEND_URL}/api/crm/cliente/proiezione/${encodeURIComponent(id)}?session_token=${encodeURIComponent(getClienteSession())}`,
};
